import * as React from "react";
import styled from "styled-components";

//import IStep from "./step";
import { Table, Col, Row } from "react-bootstrap";

export const TableWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr> td {
        font-size: 11px;
    }
`;

export const SwapTrackStepWrapper = styled.div`
    height: 30px;
    flex-basis: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    position: relative;
    //max-width: 200px;
`;

export const SwapTrackerStepContentWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 0 20px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
`;

interface ISwapTrackerStepLabel {
    color?: string,
    badgeColor?: string
}

export const SwapTrackerStepLabelWrapper = styled.div`
    color: ${(p: ISwapTrackerStepLabel) => p.color ? p.color : "white"};
    opacity: 1;
    font-size: 16px;
    font-weight: 600;

    & > .badge {
        background-color: ${(p: ISwapTrackerStepLabel) => p.badgeColor ? p.badgeColor + " !important" : "#777"}
        color: ${(p: ISwapTrackerStepLabel) => p.color ? p.color : "#fff"}
    }
`;

export const SwapTrackerRowWrapper = styled(Row)`
    font-size: 12px;
`;

interface IColProps {
    height?: number
}

export const SwapTrackerColWrapper = styled(Col)`
    padding-left: 5px;
    padding-right: 5px;
    min-height: ${ (p: IColProps) => p.height ? p.height + "px" : "30px"};
    display: flex;
    align-items: center;
`;

interface IStatusProps {
    backgroundColor: string,
    color: string
}

export const SwapTrackerStatusWrapper = styled.div`
    width: 100%;
    background-color: ${ (p: IStatusProps) => p.backgroundColor}
    color: ${ (p: IStatusProps) => p.color};
    text-align: center;
    height: 20px;
    line-height: 20px;
`;